import React from 'react';
import { Link } from "react-router-dom";
import { Container, Button, Link as Linkba, lightColors, darkColors } from "react-floating-action-button";
/* Carga de Iconos Material Community */
import Icon from '@mdi/react'
import { mdiAccountMultiplePlusOutline, mdiPackageUp, mdiPackageDown, mdiClose} from '@mdi/js'

// constantes
import { colorPrm } from "../../constants";

/* Estilos personalizados Buttons Actions */
import "./ButtonActions.scss";

export default function ButtonAct() {

    return (
    <Container>
        <Linkba
            styles={{backgroundColor: "#4885ed", color: lightColors.white}}
            tooltip="REGISTRAR USUARIOS"
             ><Link to="/register-user" className="link-ba"><Icon path={mdiAccountMultiplePlusOutline}
             size={1}
             horizontal
             /></Link></Linkba>
        <Linkba
            styles={{backgroundColor: "#db3236", color: lightColors.white}}
            tooltip="CARGAR INVENTARIO"
             ><Link to="/upload-inventory" className="link-ba"><Icon path={mdiPackageUp}
             size={1}
             horizontal
             /></Link></Linkba>
        <Linkba className="link-ba"
            styles={{backgroundColor: "#3cba54", color: lightColors.white}}
            tooltip="DESCARGAR INVENTARIO"
             ><Link to="/download-inventory" className="link-ba"><Icon path={mdiPackageDown}
             size={1}
             horizontal
             /></Link></Linkba>
        <Button
            tooltip="Mas Acciones!"
            rotate={true}
            styles={{backgroundColor: colorPrm, color: lightColors.white}}
            ><Icon path={mdiClose}
            size={1}
            horizontal
            /></Button>
    </Container>

    );

}